import { Box } from '@mui/material';
import clsx from 'clsx';

import { iconBtnType, IconButton, Icons, Text } from '../../../../../packages';

import { useStyles } from './PriorityEmpty.styles';

const PriorityEmpty = ({
  title,
  description,
  addText,
  className,
  icon = 'plus',
  onAdd,
  glyph = 'alfie-outlined',
  glyphOrientation = 'square',
  isEmptyWithLottie = false,
  lottieSize = 128,
}) => {
  const classes = useStyles({ lottieSize });
  const isLandscape = glyphOrientation === 'landscape';
  const isPortrait = glyphOrientation === 'portrait';
  const isSquare = glyphOrientation === 'square';
  return (
    <Box className={clsx(classes.noContent, className)}>
      <Icons
        glyph={glyph}
        className={clsx({
          [classes.alifie_landscape]: isLandscape,
          [classes.alfie_portrait]: isPortrait,
          [classes.alfie]: isSquare,
          [classes.lottieSize]: isEmptyWithLottie,
        })}
      />
      <Box display="flex" flexDirection="column" alignItems="center">
        <Text className={clsx(classes.title, className)}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Box>
      {onAdd && addText && (
        <IconButton className={classes.addBtn} icon={icon} variant={iconBtnType.PRIMARY} onClick={onAdd}>
          {addText}
        </IconButton>
      )}
    </Box>
  );
};

export { PriorityEmpty };
